import HwzComponent from '../../../common/component/HwzComponent';
import { Link, RouteComponentProps } from 'react-router-dom';
import Pager from '../../../common/model/base/Pager';
import SpaceMember, {
  SpaceMemberFormValues,
  DeptBatchOperationResponse,
  DeptSyncOperationResponse
} from '../../../common/model/space/member/SpaceMember';
import Lang from '../../../common/model/global/Lang';
import { 
  Button, 
  Modal, 
  Table, 
  Tag, 
  Tooltip, 
  Typography, 
  Card,
  Row,
  Col,
  TreeSelect,
  message,
  Space as AntdSpace,
  Badge,
  Alert,
  Popconfirm,
  Radio,
  RadioChangeEvent,
  Switch,
  Form,
  Input,
  Select,
  Checkbox
} from 'antd';
import HwzTitle from '../../widget/HwzTitle';
import React from 'react';
import TableEmpty from '../../widget/TableEmpty';
import SortDirection from '../../../common/model/base/SortDirection';
import { ColumnsType } from 'antd/es/table';
import User from '../../../common/model/user/User';
import Moon from '../../../common/model/global/Moon';
import {
  SpaceMemberRole,
  getSpaceMemberRoleDescription,
  getSpaceMemberRoleMap
} from '../../../common/model/space/member/SpaceMemberRole';

import DateUtil from '../../../common/util/DateUtil';
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleFilled,
  ApartmentOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  SyncOutlined,
  UserOutlined,
  SettingOutlined,
  ReloadOutlined,
  InfoCircleOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  SearchOutlined,
  DownOutlined,
  UpOutlined
} from '@ant-design/icons';
import Color from '../../../common/model/base/option/Color';
import MessageBoxUtil from '../../../common/util/MessageBoxUtil';
import ModalForm from './widget/ModalForm';
import Space from '../../../common/model/space/Space';
import { FormInstance } from 'antd/lib/form';

interface IProps
  extends RouteComponentProps<{
    spaceUuid: string;
  }> {}

interface IState {
  deptTreeData: any[];
  deptLoading: boolean;
  selectedDeptIds: string[];
  batchModalVisible: boolean;
  syncDeptMembersLoading: boolean;
  space: Space;
  loadingStats: boolean;
  roleUpdateModal: {
    visible: boolean;
    selectedDeptIds: string[];
    role: SpaceMemberRole;
  };
  batchAddRole: SpaceMemberRole;
  filterByDept: boolean | null;
  selectedDeptId: string | null;
  searchKeyword: string;
  filterRole: SpaceMemberRole | null;
  expandAllDepts: boolean;
  includeSubDepts: boolean;
  showAdvancedOptions: boolean;
}

export default class SpaceMemberList extends HwzComponent<IProps, IState> {
  spaceUuid = this.props.match.params.spaceUuid;
  pager = new Pager<SpaceMember>(this, SpaceMember, 10);
  currentUser: User = Moon.getSingleton().user;
  spaceMember = new SpaceMember(); // 当前用户在当前空间下的身份
  
  // 创建 SpaceMember 实例用于调用实例方法
  spaceMemberInstance = new SpaceMember(this);
  
  // 缓存角色映射
  spaceMemberRoleMap = getSpaceMemberRoleMap();
  
  formRef = React.createRef<FormInstance>();

  modalState: {
    visible: boolean;
    mode: 'create' | 'edit';
    initialValues?: SpaceMemberFormValues;
  } = {
    visible: false,
    mode: 'create',
  };

  constructor(props: IProps) {
    super(props);
    
    this.state = {
      deptTreeData: [],
      deptLoading: false,
      selectedDeptIds: [],
      batchModalVisible: false,
      syncDeptMembersLoading: false,
      space: new Space(),
      loadingStats: false,
      roleUpdateModal: {
        visible: false,
        selectedDeptIds: [],
        role: SpaceMemberRole.READ_WRITE
      },
      batchAddRole: SpaceMemberRole.READ_WRITE,
      filterByDept: null,
      selectedDeptId: null,
      searchKeyword: '',
      filterRole: null,
      expandAllDepts: true,
      includeSubDepts: true,
      showAdvancedOptions: false
    };
  }

  componentDidMount() {
    this.pager.enableHistory();
    this.pager.setFilterValue('spaceUuid', this.spaceUuid);
    this.spaceMember.httpMine(this.spaceUuid, () => {
      this.updateUI();
      // 设置排序
      this.pager.setFilterValue('orderCreateTime', SortDirection.DESC);
    });
    
    // 获取部门树数据
    this.fetchDeptTreeData();
    
    // 获取空间详情，检查是否有绑定部门
    this.fetchSpaceDetail();
    
    this.refresh();
  }

  // 获取部门树形数据
  fetchDeptTreeData = () => {
    this.setState({ deptLoading: true });
    
    const requestBody = {
      page: 0,
      pageSize: 1000,
      orderIndex: 'ASC'
    };
    
    fetch('/api/sys/dept/page', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(requestBody)
    })
    .then(response => response.json())
    .then(data => {
      const treeData = this.convertDataFromBackend(data);
      const treeSelectData = this.convertToTreeSelectData(treeData);
      
      this.setState({ 
        deptTreeData: treeSelectData,
        deptLoading: false 
      });
    })
    .catch(error => {
      console.error('获取部门数据失败:', error);
      this.setState({ deptLoading: false });
    });
  };

  // 获取空间详情
  fetchSpaceDetail = () => {
    const space = new Space();
    space.uuid = this.spaceUuid;
    space.httpDetail(() => {
      this.setState({ 
        space,
        selectedDeptIds: space.deptIds || []
      });
    });
  };

  // 数据转换方法
  convertDataFromBackend = (rawData: any): any[] => {
    if (!rawData) return [];
    
    let records: any[] = [];
    
    if (rawData.code === "OK" || rawData.code === "SUCCESS" || rawData.Code === "OK") {
      const dataField = rawData.data || rawData.Data;
      if (dataField) {
        if (dataField.records && Array.isArray(dataField.records)) {
          records = dataField.records;
        } else if (Array.isArray(dataField)) {
          records = dataField;
        }
      }
    } else if (Array.isArray(rawData)) {
      records = rawData;
    }
    
    // 处理树形结构数据
    const processTreeData = (nodes: any[]): any[] => {
      return nodes.map(node => {
        const processedNode = { ...node };
        
        if (processedNode.Children && Array.isArray(processedNode.Children)) {
          processedNode.children = processTreeData(processedNode.Children);
          delete processedNode.Children;
        } else if (processedNode.children && Array.isArray(processedNode.children)) {
          processedNode.children = processTreeData(processedNode.children);
        }
        
        if (processedNode.id) {
          processedNode.key = processedNode.id.toString();
        }
        
        return processedNode;
      });
    };
    
    return processTreeData(records);
  };

  // 将树形数据转换为TreeSelect需要的格式
  convertToTreeSelectData = (nodes: any[]): any[] => {
    if (!nodes || nodes.length === 0) return [];
    
    return nodes.map(node => {
      const treeNode: any = {
        title: node.shortName || node.name || Lang.t('department.department'),
        value: node.id ? node.id.toString() : '',
        key: node.id ? node.id.toString() : '',
        rawData: node,
        isLeaf: !node.children || node.children.length === 0,
        disableCheckbox: false
      };
      
      if (node.children && Array.isArray(node.children) && node.children.length > 0) {
        treeNode.children = this.convertToTreeSelectData(node.children);
      } else {
        treeNode.children = [];
      }
      
      return treeNode;
    });
  };

  // 根据部门ID查找部门信息
  findDeptById = (deptId: string): any => {
    const findInTree = (nodes: any[]): any => {
      for (const node of nodes) {
        if (node.value === deptId) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = findInTree(node.children);
          if (found) {
            return found;
          }
        }
      }
      return null;
    };
    
    return findInTree(this.state.deptTreeData);
  };

  // 获取部门的所有子部门ID
  getAllChildrenDeptIds = (deptId: string): string[] => {
    const childrenIds: string[] = [];
    
    const findChildren = (node: any): void => {
      if (node.value === deptId || childrenIds.length > 0) {
        // 找到目标节点，开始收集子节点
        if (node.children && node.children.length > 0) {
          node.children.forEach((child: any) => {
            childrenIds.push(child.value);
            findChildren(child);
          });
        }
      } else if (node.children && node.children.length > 0) {
        node.children.forEach((child: any) => findChildren(child));
      }
    };
    
    this.state.deptTreeData.forEach(node => findChildren(node));
    return childrenIds;
  };

  // 获取需要实际处理的部门ID列表
  getProcessDeptIds = (selectedDeptIds: string[], includeSubDepts: boolean): string[] => {
    if (!includeSubDepts) {
      return [...selectedDeptIds];
    }
    
    const allDeptIds = new Set<string>();
    
    selectedDeptIds.forEach(deptId => {
      allDeptIds.add(deptId);
      
      const childrenIds = this.getAllChildrenDeptIds(deptId);
      childrenIds.forEach(childId => {
        allDeptIds.add(childId);
      });
    });
    
    return Array.from(allDeptIds);
  };

  // 打开部门批量添加模态框
  handleOpenBatchModal = () => {
    const { space } = this.state;
    this.setState({ 
      batchModalVisible: true,
      selectedDeptIds: space.deptIds || [],
      batchAddRole: SpaceMemberRole.READ_WRITE,
      includeSubDepts: true
    });
  };

  // 关闭部门批量添加模态框
  handleCloseBatchModal = () => {
    this.setState({ 
      batchModalVisible: false,
      selectedDeptIds: [] 
    });
  };

  // 处理批量添加角色选择变更
  handleBatchAddRoleChange = (e: RadioChangeEvent) => {
    this.setState({ batchAddRole: e.target.value });
  };

  // 处理是否包含子部门变更
  handleIncludeSubDeptsChange = (e: RadioChangeEvent) => {
    this.setState({ includeSubDepts: e.target.value });
  };

  // 切换高级选项显示
  handleToggleAdvancedOptions = () => {
    this.setState({ showAdvancedOptions: !this.state.showAdvancedOptions });
  };

  // 处理全选所有部门
  handleSelectAllDepts = () => {
    const getAllDeptIds = (treeData: any[]): string[] => {
      const ids: string[] = [];
      const traverse = (nodes: any[]) => {
        nodes.forEach(node => {
          if (node.value) {
            ids.push(node.value);
          }
          if (node.children && node.children.length > 0) {
            traverse(node.children);
          }
        });
      };
      traverse(treeData);
      return ids;
    };
    
    const allDeptIds = getAllDeptIds(this.state.deptTreeData);
    this.setState({ selectedDeptIds: allDeptIds });
  };

  // 处理清空所有选择
  handleClearAllDepts = () => {
    this.setState({ selectedDeptIds: [] });
  };

  handleBatchAddByDept = () => {
    const { selectedDeptIds, batchAddRole, includeSubDepts } = this.state;
    
    if (selectedDeptIds.length === 0) {
      message.warning(Lang.t('department.selectFirst'));
      return;
    }

    const processDeptIds = this.getProcessDeptIds(selectedDeptIds, includeSubDepts);
    
    if (processDeptIds.length === 0) {
      message.warning(Lang.t('department.noDeptToAdd'));
      return;
    }

    const roleName = this.spaceMemberRoleMap[batchAddRole]?.name || Lang.t('space.memberRoleReadWrite');
    
    const getDeptName = (deptId: string) => {
      const dept = this.findDeptById(deptId);
      return dept ? dept.title : Lang.t('department.department');
    };

    const selectedCount = selectedDeptIds.length;
    const processCount = processDeptIds.length;
    const subDeptCount = processCount - selectedCount;

    Modal.confirm({
      title: Lang.t('space.bindMember'),
      icon: <ExclamationCircleFilled />,
      content: (
        <div>
          <p>{Lang.t('space.confirmBatchAddDeptMembers')}</p>
          
          <div style={{ margin: '12px 0', padding: '12px', backgroundColor: '#f6ffed', borderRadius: 4 }}>
            <div style={{ marginBottom: 8 }}>
              <strong>{Lang.t('space.addMode')}:</strong> {
                includeSubDepts 
                  ? Lang.t('department.includeSubDepts') 
                  : Lang.t('department.excludeSubDepts')
              }
            </div>
            
            <div style={{ marginBottom: 8 }}>
              <strong>{Lang.t('space.selectedDepts')}:</strong> {Lang.t('department.selectedDepartmentsCount', selectedCount)}
              {selectedCount > 0 && (
                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                  {selectedDeptIds.slice(0, 3).map((deptId, index) => (
                    <div key={index}>• {getDeptName(deptId)}</div>
                  ))}
                  {selectedCount > 3 && (
                     <div>{Lang.t('space.andMoreDepts')}</div>
                  )}
                </div>
              )}
            </div>
            
            {includeSubDepts && subDeptCount > 0 && (
              <div style={{ marginBottom: 8 }}>
                <strong>{Lang.t('space.subDeptsToAdd')}:</strong> {Lang.t('department.totalAffectedDepts', subDeptCount)}
              </div>
            )}
            
            <div>
              <strong>{Lang.t('space.totalDeptsToProcess')}:</strong> {Lang.t('department.totalAffectedDepts', processCount)}
            </div>
            
            <div style={{ marginTop: 8 }}>
              <strong>{Lang.t('space.memberRole')}:</strong> 
              <Tag color={this.spaceMemberRoleMap[batchAddRole]?.color} style={{ marginLeft: 8 }}>
                {roleName}
              </Tag>
            </div>
          </div>
          
          <Alert
            type="info"
            message={Lang.t('space.processRules')}
            description={
              <ul style={{ marginBottom: 0, paddingLeft: 16 }}>
                <li>{Lang.t('space.addAllUsersInDept')}</li>
                <li>{Lang.t('space.skipExistingMembers')}</li>
                <li>{Lang.t('space.eachDeptIndependent')}</li>
              </ul>
            }
            showIcon
          />
        </div>
      ),
      okText: Lang.t('space.startAdd'),
      cancelText: Lang.t('common.cancel'),
      onOk: () => {
        this.batchAddDeptMembers(processDeptIds, batchAddRole);
      },
    });
  };

  fixApiErrorMessage = (message: string): string => {
    if (!message || message.trim() === '') {
      return Lang.t('common.operationComplete');
    }
    
    console.log('原始API消息:', message);
    
    // 处理特定的消息格式 - 使用固定文本替换
    let fixedMessage = message;
    
    // 1. 处理 "将为选中的 将为选中的 {0} 个部门批量创建空间： 个部门批量创建空间："
    if (fixedMessage.includes('将为选中的') && fixedMessage.includes('个部门批量创建空间')) {
      fixedMessage = Lang.t('message.willCreateSpaceForSelectedDepts');
    }
    
    // 2. 处理 "批量创建成功，共创建 批量创建成功，共创建 {0} 个空间 个空间"
    else if (fixedMessage.includes('批量创建成功，共创建') && fixedMessage.includes('个空间')) {
      fixedMessage = Lang.t('message.batchCreateSuccess');
    }
    
    // 3. 处理 "将为以下 将为以下 {0} 个部门创建空间： 个部门创建空间："
    else if (fixedMessage.includes('将为以下') && fixedMessage.includes('个部门创建空间')) {
      fixedMessage = Lang.t('message.willCreateSpaceForFollowingDepts');
    }
    
    // 4. 处理其他常见格式
    else if (fixedMessage.includes('部分成功：成功')) {
      fixedMessage = Lang.t('message.partialSuccess');
    }
    
    else if (fixedMessage.includes('批量添加成功，共添加')) {
      fixedMessage = Lang.t('message.batchAddSuccess');
    }
    
    else if (fixedMessage.includes('同步完成：新增')) {
      fixedMessage = Lang.t('message.syncComplete');
    }
    
    else if (fixedMessage.includes('部分更新成功：')) {
      fixedMessage = Lang.t('message.partialUpdateSuccess');
    }
    
    else if (fixedMessage.includes('已选择')) {
      fixedMessage = fixedMessage.replace(/已选择.*个部门/, Lang.t('message.selectedDepts'));
    }
    
    else if (fixedMessage.includes('共')) {
      fixedMessage = fixedMessage.replace(/共.*个部门/, Lang.t('message.totalSelectedDepts'));
    }
    
    // 5. 如果以上都不是，清理消息中的数字和占位符
    else {
      // 移除所有 {0}、{1} 等占位符
      fixedMessage = fixedMessage.replace(/\{[0-9]+\}/g, '');
      
      // 移除重复内容
      const duplicates = [
        '将为选中的',
        '个部门批量创建空间',
        '批量创建成功，共创建',
        '个空间',
        '将为以下',
        '个部门创建空间',
        '部分成功：成功',
        '批量添加成功，共添加',
        '同步完成：新增',
        '部分更新成功：',
        '已选择',
        '共',
        '个部门'
      ];
      
      duplicates.forEach(dup => {
        const doubleDup = `${dup} ${dup}`;
        if (fixedMessage.includes(doubleDup)) {
          fixedMessage = fixedMessage.replace(doubleDup, dup);
        }
        
        // 移除单独的数字和单位
        const pattern = new RegExp(`\\d+\\s*${dup}`, 'g');
        fixedMessage = fixedMessage.replace(pattern, dup);
      });
    }
    
    // 清理额外的空格和标点
    fixedMessage = fixedMessage
      .replace(/\s+/g, ' ') // 多个空格合并为一个
      .replace(/\s+：/g, '：') // 删除冒号前的空格
      .replace(/：\s+/g, '：') // 删除冒号后的空格
      .replace(/[。]+/g, '。') // 多个句号合并为一个
      .replace(/[！]+/g, '！') // 多个感叹号合并为一个
      .trim();
    
    // 如果消息过于简短，添加默认消息
    if (fixedMessage.length < 3) {
      fixedMessage = Lang.t('common.operationComplete');
    }
    
    console.log('修复后的消息:', fixedMessage);
    return fixedMessage;
  };
  
  showFixedMessage = (type: 'success' | 'warning' | 'error' | 'info', message: string) => {
    let fixedMessage = this.fixApiErrorMessage(message);
    
    if (!fixedMessage || fixedMessage.trim() === '') {
      fixedMessage = Lang.t('common.operationComplete');
    }
    
    let finalType = type;
    const msg = fixedMessage.toLowerCase();
    
    if (msg.includes('成功') || msg.includes('完成') || msg.includes('添加') || msg.includes('创建') || msg.includes('更新')) {
      finalType = 'success';
    } else if (msg.includes('失败') || msg.includes('错误') || msg.includes('异常')) {
      finalType = 'error';
    } else if (msg.includes('警告') || msg.includes('注意') || msg.includes('部分') || msg.includes('跳过')) {
      finalType = 'warning';
    } else if (msg.includes('提示') || msg.includes('信息') || msg.includes('状态') || msg.includes('同步')) {
      finalType = 'info';
    }
    
    console.log('显示消息:', { 
      original: message, 
      fixed: fixedMessage, 
      type: finalType 
    });
    
    switch (finalType) {
      case 'success':
        MessageBoxUtil.success(fixedMessage);
        break;
      case 'warning':
        MessageBoxUtil.warning(fixedMessage);
        break;
      case 'error':
        MessageBoxUtil.error(fixedMessage);
        break;
      case 'info':
        MessageBoxUtil.info(fixedMessage);
        break;
    }
  };

  batchAddDeptMembers = (deptIds: string[], role: SpaceMemberRole) => {
    this.setState({ syncDeptMembersLoading: true });
    
    console.log('批量添加部门成员请求参数:', {
      spaceUuid: this.spaceUuid,
      deptIds: deptIds,
      deptCount: deptIds.length,
      role: role,
      note: Lang.t('space.eachDeptIndependent')
    });
    
    this.spaceMemberInstance.httpBatchAddByDept(
      this.spaceUuid,
      deptIds,
      role,
      (result: DeptBatchOperationResponse & { results?: any[] }) => {
        console.log('批量添加结果详情:', result);
        
        const { successCount, errorCount } = result;
        
        if (result.results && Array.isArray(result.results)) {
          result.results.forEach((deptResult: any) => {
            const dept = this.findDeptById(deptResult.deptId);
            const deptName = dept ? dept.title : Lang.t('department.department');
            
            if (deptResult.success) {
              console.log(Lang.t('log.deptAddSuccess', deptName));
            } else {
              console.error(Lang.t('log.deptAddFail', deptName), deptResult.errorMessage || Lang.t('common.unknownError'));
            }
          });
        }
        
        if (result.message) {
          this.showFixedMessage(errorCount > 0 ? 'warning' : 'success', result.message);
        } else if (successCount > 0 || errorCount > 0) {
          if (errorCount > 0) {
            this.showFixedMessage('warning', Lang.t('message.partialSuccess'));
          } else if (successCount > 0) {
            this.showFixedMessage('success', Lang.t('message.batchAddSuccess'));
          } else {
            this.showFixedMessage('info', Lang.t('department.noUsersInDept'));
          }
        } else {
          this.showFixedMessage('info', Lang.t('space.noMemberAdded'));
        }
        
        // 移除错误的 updateSpaceDeptBindings 调用
        // this.handleCloseBatchModal();
        // this.updateSpaceDeptBindings(deptIds); // 这行会导致问题！
        // this.refresh();
        
        // 改为直接关闭模态框并刷新
        this.handleCloseBatchModal();
        this.refresh();
        this.setState({ syncDeptMembersLoading: false });
      },
      (error: any) => {
        console.error(Lang.t('space.batchAddFail'), error);
        
        if (error && error.message) {
          this.showFixedMessage('error', error.message);
        } else {
          this.showFixedMessage('error', Lang.t('common.operationFailed'));
        }
        
        this.setState({ syncDeptMembersLoading: false });
      }
    );
  };

// 移除 updateSpaceDeptBindings 方法或者修改为只更新本地状态
updateSpaceDeptBindings = (deptIds: string[]) => {
  const { space } = this.state;
  
  const selectedDepts = deptIds.map(deptId => {
    const dept = this.findDeptById(deptId);
    return {
      id: deptId,
      name: dept ? dept.title : Lang.t('department.department')
    };
  });
  
  // 只更新本地状态，不调用 httpSave
  space.deptIds = deptIds;
  space.deptNames = selectedDepts.map(dept => dept.name);
  this.setState({ space });
  
  console.log(Lang.t('log.spaceDeptBindingUpdatedLocal'));
};

  // 同步部门成员（重新同步已绑定的部门）
  handleSyncDeptMembers = () => {
    const { space } = this.state;
    
    if (!space.deptIds || space.deptIds.length === 0) {
      message.warning(Lang.t('department.noBoundDepartments'));
      return;
    }

    Modal.confirm({
      title: Lang.t('department.syncDeptMembers'),
      icon: <ExclamationCircleFilled />,
      content: (
        <div>
          <p>{Lang.t('department.confirmSyncDeptMembers')}</p>
          <Alert
            type="warning"
            message={Lang.t('common.warning')}
            description={Lang.t('department.syncWarning')}
            showIcon
          />
          <div style={{ marginTop: 12 }}>
            <p>{Lang.t('department.syncAffectedDepts')}</p>
            <ul style={{ maxHeight: 150, overflowY: 'auto', paddingLeft: 20 }}>
              {space.deptIds.map((deptId, index) => {
                const dept = this.findDeptById(deptId);
                return (
                  <li key={index}>
                    {dept ? dept.title : Lang.t('department.department')}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      ),
      okText: Lang.t('department.startSync'),
      cancelText: Lang.t('common.cancel'),
      onOk: () => {
        this.syncDeptMembers();
      },
    });
  };

  // 同步部门成员
  syncDeptMembers = () => {
    this.setState({ syncDeptMembersLoading: true });
    
    const { space } = this.state;
    
    const handleComplete = () => {
      this.setState({ syncDeptMembersLoading: false });
    };
    
    this.spaceMemberInstance.httpSyncDeptMembers(
      this.spaceUuid,
      space.deptIds!,
      true,
      (result: DeptSyncOperationResponse) => {
        if (result.addedCount === 0 && result.removedCount === 0) {
          this.showFixedMessage('info', Lang.t('department.memberStatusUpToDate'));
        } else {
          this.showFixedMessage('success', Lang.t('department.syncComplete'));
        }
        
        this.refresh();
        handleComplete();
      },
      (error: any) => {
        console.error(Lang.t('department.syncDeptMembersFail'), error);
        this.showFixedMessage('error', error.message || Lang.t('common.syncFailed'));
        handleComplete();
      }
    );
  };

  // 批量移除部门成员
  handleBatchRemoveByDept = (deptId: string, deptName: string) => {
    Modal.confirm({
      title: Lang.t('department.removeDeptBinding'),
      icon: <ExclamationCircleFilled />,
      content: (
        <div>
          <p>{Lang.t('department.confirmRemoveDept')}</p>
          <p>{Lang.t('department.afterRemove')}</p>
          <ul>
            <li>1. {Lang.t('department.noAutoSync')}</li>
            <li>2. <strong style={{ color: Color.DANGER }}>
              {Lang.t('department.existingMembersNotDeleted')}
            </strong></li>
            <li>3. {Lang.t('department.canRebindLater')}</li>
          </ul>
        </div>
      ),
      okText: Lang.t('common.confirm'),
      cancelText: Lang.t('common.cancel'),
      okType: 'danger',
      onOk: () => {
        this.removeDeptBinding(deptId);
      },
    });
  };

  // 移除部门绑定
  removeDeptBinding = (deptId: string) => {
    const handleComplete = () => {
      // 移除完成后的处理
    };
    
    this.spaceMemberInstance.httpBatchRemoveByDept(
      this.spaceUuid,
      [deptId],
      (result: DeptBatchOperationResponse) => {
        if (result.successCount > 0) {
          this.showFixedMessage('success', Lang.t('department.deptBindingRemoved'));
          
          const { space } = this.state;
          const newDeptIds = space.deptIds?.filter(id => id !== deptId) || [];
          
          this.updateSpaceDeptBindings(newDeptIds);
        }
        handleComplete();
      },
      (error: any) => {
        console.error(Lang.t('department.removeDeptBindingFail'), error);
        this.showFixedMessage('error', error.message || Lang.t('common.operationFailed'));
        handleComplete();
      }
    );
  };

  // 打开批量更新角色模态框
  handleOpenRoleUpdateModal = () => {
    const { space } = this.state;
    this.setState({
      roleUpdateModal: {
        visible: true,
        selectedDeptIds: space.deptIds || [],
        role: SpaceMemberRole.READ_WRITE
      }
    });
  };

  // 批量更新部门成员角色
  handleBatchUpdateRole = () => {
    const { roleUpdateModal } = this.state;
    
    if (roleUpdateModal.selectedDeptIds.length === 0) {
      message.warning(Lang.t('department.selectDepts'));
      return;
    }

    const allDeptIdsToProcess = this.getProcessDeptIds(roleUpdateModal.selectedDeptIds, true);
    const roleName = this.spaceMemberRoleMap[roleUpdateModal.role]?.name || Lang.t('space.memberRoleReadWrite');
    
    Modal.confirm({
      title: Lang.t('department.batchUpdateDeptRole'),
      icon: <ExclamationCircleFilled />,
      content: (
        <div>
          <p>{Lang.t('department.confirmBatchUpdateRole', roleName)}</p>
          <Alert
            type="warning"
            message={Lang.t('common.warning')}
            description={Lang.t('department.roleUpdateWarning')}
            showIcon
            style={{ marginTop: 10 }}
          />
          {allDeptIdsToProcess.length > 10 && (
            <Alert
              type="info"
              message={Lang.t('department.affectedDepartments')}
              description={Lang.t('department.totalAffectedDepts', allDeptIdsToProcess.length)}
              showIcon
              style={{ marginTop: 10 }}
            />
          )}
        </div>
      ),
      okText: Lang.t('department.batchUpdate'),
      cancelText: Lang.t('common.cancel'),
      onOk: () => {
        this.batchUpdateDeptMemberRole(allDeptIdsToProcess, roleUpdateModal.role);
      },
    });
  };

  // 执行批量更新角色
  batchUpdateDeptMemberRole = (deptIds: string[], role: SpaceMemberRole) => {
    const handleComplete = () => {
      // 更新完成后的处理
    };
    
    this.spaceMemberInstance.httpBatchUpdateDeptMemberRole(
      this.spaceUuid,
      deptIds,
      role,
      (result) => {
        if (result.errorCount === 0) {
          this.showFixedMessage('success', Lang.t('common.operationSuccess'));
        } else {
          this.showFixedMessage('warning', Lang.t('space.partialSuccess'));
        }
        
        this.setState({
          roleUpdateModal: {
            visible: false,
            selectedDeptIds: [],
            role: SpaceMemberRole.READ_WRITE
          }
        });
        
        this.refresh();
        handleComplete();
      },
      (error) => {
        console.error(Lang.t('department.batchUpdateRoleFail'), error);
        this.showFixedMessage('error', error.message || Lang.t('common.operationFailed'));
        handleComplete();
      }
    );
  };

  handleCreate() {
    this.modalState = {
      visible: true,
      mode: 'create',
    };
    this.updateUI();
  }

  refresh() {
    if (!this.pager.getCurrentSortFilter()) {
      this.pager.setFilterValue('orderCreateTime', SortDirection.DESC);
    }
    
    // 应用过滤器
    this.applyFilters();
    
    this.pager.httpList();
  }

  // 应用过滤器
  applyFilters = () => {
    const { filterByDept, selectedDeptId, searchKeyword, filterRole } = this.state;
    
    this.pager.setFilterValue('spaceUuid', this.spaceUuid);
    
    if (filterByDept !== null && selectedDeptId) {
      this.pager.setFilterValue('deptId', selectedDeptId);
    }
    
    if (searchKeyword) {
      this.pager.setFilterValue('user.username', `%${searchKeyword}%`);
    }
    
    if (filterRole) {
      this.pager.setFilterValue('role', filterRole);
    }
    
    this.pager.setFilterValue('orderCreateTime', SortDirection.DESC);
  };

  // 处理搜索
  handleSearch = (value: string) => {
    this.setState({ searchKeyword: value }, () => {
      this.refresh();
    });
  };

  // 处理部门过滤
  handleDeptFilterChange = (deptId: string | null) => {
    this.setState({ 
      selectedDeptId: deptId,
      filterByDept: deptId !== null
    }, () => {
      this.refresh();
    });
  };

  // 处理角色过滤
  handleRoleFilterChange = (role: SpaceMemberRole | null) => {
    this.setState({ filterRole: role }, () => {
      this.refresh();
    });
  };

  // 重置所有过滤器
  handleResetFilters = () => {
    this.setState({
      filterByDept: null,
      selectedDeptId: null,
      searchKeyword: '',
      filterRole: null
    }, () => {
      this.refresh();
    });
  };

  handleEdit(spaceMember: SpaceMember) {
    this.modalState = {
      visible: true,
      mode: 'edit',
      initialValues: spaceMember.getForm(),
    };
    this.updateUI();
  }

  handleDelete(spaceMember: SpaceMember) {
    const isDeptMember = spaceMember.isDeptMember || spaceMember.isFromDept?.() || false;
    
    const modalContent = isDeptMember ? (
      <div>
        <p>{Lang.t('space.deleteDeptMemberWarningFull')}</p>
        <ul style={{ margin: '8px 0', paddingLeft: 16 }}>
          <li>{Lang.t('member.willNotAutoAddAgain')}</li>
          <li>{Lang.t('member.canManuallyReadd')}</li>
          <li>{Lang.t('member.deptSyncWillSkip')}</li>
        </ul>
        <Alert 
          type="warning" 
          message={Lang.t('member.syncWillNotReadd')}
          showIcon 
        />
      </div>
    ) : Lang.t('space.memberUnbindConfirmDesc');
    
    Modal.confirm({
      title: isDeptMember 
        ? Lang.t('member.deleteDeptMemberConfirm')
        : Lang.t('space.memberUnbindConfirm'),
      icon: <ExclamationCircleFilled />,
      content: modalContent,
      cancelText: Lang.t('common.cancel'),
      okText: Lang.t('common.confirm'),
      okType: isDeptMember ? 'danger' : 'danger',
      onOk: () => {
        spaceMember.httpDel(() => {
          this.showFixedMessage('success', Lang.t('common.operationSuccess'));
          this.refresh();
        });
      },
    });
  }

  // 批量删除部门成员
  handleBatchDeleteDeptMembers = (deptId: string) => {
    Modal.confirm({
      title: Lang.t('department.deleteDeptMembers'),
      icon: <ExclamationCircleFilled />,
      content: Lang.t('department.confirmDeleteDeptMembers'),
      okText: Lang.t('common.delete'),
      cancelText: Lang.t('common.cancel'),
      okType: 'danger',
      onOk: () => {
        this.batchDeleteDeptMembers(deptId);
      },
    });
  };

  // 执行批量删除部门成员
  batchDeleteDeptMembers = (deptId: string) => {
    const handleComplete = () => {
      this.refresh();
    };
    
    console.log(Lang.t('log.batchDeleteDeptMembers', deptId));
    handleComplete();
  };

  handleConfirmModalForm(values: SpaceMemberFormValues) {
    const spaceMember = new SpaceMember();
    spaceMember.spaceUuid = this.spaceUuid;
    spaceMember.assign(values);
    spaceMember.httpSave(
      () => {
        this.showFixedMessage('success', Lang.t('common.operationSuccess'));
        this.refresh();
      },
      null,
      () => this.handleHideModalForm()
    );
  }

  handleHideModalForm() {
    this.modalState = {
      ...this.modalState,
      visible: false,
    };
    this.updateUI();
  }

  // 渲染过滤器工具栏
  renderFilterToolbar = () => {
    const { 
      searchKeyword, 
      selectedDeptId, 
      filterRole,
      deptTreeData,
      deptLoading
    } = this.state;

    return (
      <Card size="small" style={{ marginBottom: 16 }}>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={12} md={6}>
            <div>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                {Lang.t('common.search')}
              </div>
              <Input
                placeholder={Lang.t('member.searchUsername')}
                value={searchKeyword}
                onChange={(e) => this.handleSearch(e.target.value)}
                allowClear
                suffix={<UserOutlined />}
              />
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                {Lang.t('department.filterByDept')}
              </div>
              <TreeSelect
                treeData={deptTreeData}
                value={selectedDeptId}
                onChange={this.handleDeptFilterChange}
                placeholder={Lang.t('department.selectDept')}
                style={{ width: '100%' }}
                loading={deptLoading}
                allowClear
                showSearch
                treeNodeFilterProp="title"
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              />
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                {Lang.t('member.filterRole')}
              </div>
              <Select
                value={filterRole}
                onChange={this.handleRoleFilterChange}
                placeholder={Lang.t('member.selectRole')}
                style={{ width: '100%' }}
                allowClear
              >
                <Select.Option value={null}>{Lang.t('common.all')}</Select.Option>
                {Object.entries(this.spaceMemberRoleMap).map(([role, info]) => (
                  <Select.Option key={role} value={role}>
                    <Tag color={info.color}>{info.name}</Tag>
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
          
          <Col xs={24} sm={24} md={6} style={{ textAlign: 'right', alignSelf: 'flex-end' }}>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <Button
                type="default"
                icon={<ReloadOutlined />}
                onClick={this.handleResetFilters}
              >
                {Lang.t('common.reset')}
              </Button>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={this.refresh}
              >
                {Lang.t('common.search')}
              </Button>
            </div>
          </Col>
        </Row>
      </Card>
    );
  };

  // 渲染统计信息
  renderStats = () => {
    const { pager } = this;
    
    if (pager.data.length === 0) {
      return null;
    }
    
    const totalMembers = pager.data.length;
    const deptMembers = pager.data.filter(member => member.isDeptMember).length;
    const manualMembers = totalMembers - deptMembers;
    
    const roleStats: Record<string, number> = {};
    pager.data.forEach(member => {
      const role = member.role || 'UNKNOWN';
      roleStats[role] = (roleStats[role] || 0) + 1;
    });
    
    return (
      <Card size="small" style={{ marginBottom: 16 }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <div style={{ padding: '8px 0' }}>
              <div style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 16 }}>
                {Lang.t('member.memberStatistics')}
              </div>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: 24, fontWeight: 'bold', color: '#1890ff' }}>
                      {totalMembers}
                    </div>
                    <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                      {Lang.t('member.totalMembers')}
                    </div>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: 24, fontWeight: 'bold', color: '#52c41a' }}>
                      {deptMembers}
                    </div>
                    <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                      {Lang.t('member.deptMembers')}
                    </div>
                  </div>
                </Col>
                <Col span={8}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: 24, fontWeight: 'bold', color: '#faad14' }}>
                      {manualMembers}
                    </div>
                    <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                      {Lang.t('member.manualMembers')}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          
          <Col xs={24} md={12}>
            <div style={{ padding: '8px 0' }}>
              <div style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 16 }}>
                {Lang.t('member.roleDistribution')}
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {Object.entries(roleStats).map(([role, count]) => {
                  const roleInfo = this.spaceMemberRoleMap[role as SpaceMemberRole];
                  const percentage = ((count / totalMembers) * 100).toFixed(1);
                  
                  return (
                    <div 
                      key={role}
                      style={{
                        flex: '0 0 auto',
                        padding: '8px 12px',
                        border: `1px solid ${roleInfo?.color || '#d9d9d9'}`,
                        borderRadius: 4,
                        textAlign: 'center',
                        minWidth: 80
                      }}
                    >
                      <div style={{ marginBottom: 4 }}>
                        <Tag color={roleInfo?.color} style={{ margin: 0 }}>
                          {roleInfo?.name}
                        </Tag>
                      </div>
                      <div style={{ fontSize: 14, fontWeight: 'bold' }}>
                        {count}
                      </div>
                      <div style={{ fontSize: 10, color: '#999' }}>
                        {percentage}%
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>
        </Row>
      </Card>
    );
  };

  // 渲染批量更新角色模态框
  renderRoleUpdateModal = () => {
    const { roleUpdateModal, deptTreeData, deptLoading } = this.state;
    
    return (
      <Modal
        title={
          <span>
            <SettingOutlined /> {Lang.t('department.batchUpdateTitle')}
          </span>
        }
        visible={roleUpdateModal.visible}
        onOk={this.handleBatchUpdateRole}
        onCancel={() => {
          this.setState({
            roleUpdateModal: {
              ...roleUpdateModal,
              visible: false
            }
          });
        }}
        width={600}
        okText={Lang.t('department.batchUpdate')}
        cancelText={Lang.t('common.cancel')}
      >
        <div>
          <div style={{ marginBottom: 16 }}>
            <p>{Lang.t('department.selectDepts')}:</p>
            <TreeSelect
              treeData={deptTreeData}
              value={roleUpdateModal.selectedDeptIds}
              onChange={(value) => {
                this.setState({
                  roleUpdateModal: {
                    ...roleUpdateModal,
                    selectedDeptIds: value
                  }
                });
              }}
              treeCheckable={true}
              placeholder={Lang.t('department.selectDepts')}
              style={{ width: '100%' }}
              loading={deptLoading}
              treeDefaultExpandAll
              showSearch
              treeNodeFilterProp="title"
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            />
          </div>
          
          <div style={{ marginBottom: 16 }}>
            <p>{Lang.t('department.batchUpdateSelectRole')}</p>
            <Row gutter={16}>
              {Object.entries(this.spaceMemberRoleMap).map(([role, info]) => (
                <Col span={8} key={role}>
                  <div
                    style={{
                      border: `1px solid ${roleUpdateModal.role === role ? info.color : '#d9d9d9'}`,
                      borderRadius: 4,
                      padding: 12,
                      textAlign: 'center',
                      cursor: 'pointer',
                      backgroundColor: roleUpdateModal.role === role ? `${info.color}10` : '#fff',
                      transition: 'all 0.3s'
                    }}
                    onClick={() => {
                      this.setState({
                        roleUpdateModal: {
                          ...roleUpdateModal,
                          role: role as SpaceMemberRole
                        }
                      });
                    }}
                  >
                    <Tag color={info.color}>{info.name}</Tag>
                    <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                      {getSpaceMemberRoleDescription(role as SpaceMemberRole)}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
          
          {roleUpdateModal.selectedDeptIds.length > 0 && (
            <Alert
              type="info"
              message={Lang.t('department.selectedDepartmentsCount', roleUpdateModal.selectedDeptIds.length)}
              description={Lang.t('department.batchUpdateSelectedDepartmentsDesc')}
              showIcon
            />
          )}
        </div>
      </Modal>
    );
  };

  // 渲染批量添加部门模态框 - 已修改允许选择父节点
  renderBatchAddModal = () => {
    const { 
      deptTreeData, 
      deptLoading, 
      selectedDeptIds, 
      batchModalVisible,
      batchAddRole,
      syncDeptMembersLoading,
      expandAllDepts,
      includeSubDepts,
      showAdvancedOptions
    } = this.state;

    return (
      <Modal
        title={
          <span>
            <ApartmentOutlined /> {Lang.t('department.batchAddByDept')}
          </span>
        }
        visible={batchModalVisible}
        onOk={this.handleBatchAddByDept}
        onCancel={this.handleCloseBatchModal}
        width={800}
        okText={Lang.t('department.batchAdd')}
        cancelText={Lang.t('common.cancel')}
        okButtonProps={{
          loading: syncDeptMembersLoading,
          icon: <UsergroupAddOutlined />
        }}
      >
        <div>
          <p style={{ marginBottom: 16 }}>
            {Lang.t('department.batchAddDeptHint')}
            <span style={{ color: '#1890ff', fontWeight: 'bold', marginLeft: 8 }}>
              {Lang.t('department.parentNodeHint')}
            </span>
          </p>
          
          <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <div style={{ fontWeight: 'bold' }}>
                {Lang.t('department.selectDepts')}:
              </div>
              <div>
                <Button
                  type="link"
                  size="small"
                  onClick={this.handleSelectAllDepts}
                  style={{ marginRight: 8 }}
                >
                  {Lang.t('department.selectAll')}
                </Button>
                <Button
                  type="link"
                  size="small"
                  onClick={this.handleClearAllDepts}
                >
                  {Lang.t('department.clearAll')}
                </Button>
              </div>
            </div>
            
            <TreeSelect
              treeData={deptTreeData}
              value={selectedDeptIds}
              onChange={(value) => this.setState({ selectedDeptIds: value })}
              treeCheckable={true}
              placeholder={Lang.t('department.selectDepts')}
              style={{ width: '100%', marginBottom: 16 }}
              loading={deptLoading}
              treeDefaultExpandedKeys={expandAllDepts ? deptTreeData.map(node => node.key) : []}
              showSearch
              treeNodeFilterProp="title"
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              treeCheckStrictly={true} // 允许父子节点独立选择
              showCheckedStrategy={TreeSelect.SHOW_ALL} // 显示所有选中节点
            />
          </div>
          
          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 8, fontWeight: 'bold' }}>
              {Lang.t('department.addMode')}:
            </div>
            <Radio.Group 
              value={includeSubDepts} 
              onChange={this.handleIncludeSubDeptsChange}
              style={{ width: '100%' }}
            >
              <Row gutter={[16, 8]}>
                <Col span={12}>
                  <Radio value={true} style={{ display: 'block' }}>
                    <div>
                      <div style={{ fontWeight: 'bold' }}>
                        {Lang.t('department.includeSubDepts')}
                      </div>
                      <div style={{ fontSize: 12, color: '#666' }}>
                        {Lang.t('department.includeSubDeptsDesc')}
                      </div>
                    </div>
                  </Radio>
                </Col>
                <Col span={12}>
                  <Radio value={false} style={{ display: 'block' }}>
                    <div>
                      <div style={{ fontWeight: 'bold' }}>
                        {Lang.t('department.excludeSubDepts')}
                      </div>
                      <div style={{ fontSize: 12, color: '#666' }}>
                        {Lang.t('department.excludeSubDeptsDesc')}
                      </div>
                    </div>
                  </Radio>
                </Col>
              </Row>
            </Radio.Group>
          </div>
          
          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 8, fontWeight: 'bold' }}>
              {Lang.t('setRoleHint')}:
            </div>
            <Radio.Group 
              value={batchAddRole} 
              onChange={this.handleBatchAddRoleChange}
              style={{ width: '100%' }}
            >
              <Row gutter={[16, 8]}>
                {Object.entries(this.spaceMemberRoleMap).map(([role, info]) => (
                  <Col span={8} key={role}>
                    <Radio value={role} style={{ display: 'block' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Tag color={info.color} style={{ marginRight: 4 }}>
                          {info.name}
                        </Tag>
                        <div style={{ fontSize: 12, color: '#666' }}>
                          {getSpaceMemberRoleDescription(role as SpaceMemberRole)}
                        </div>
                      </div>
                    </Radio>
                  </Col>
                ))}
              </Row>
            </Radio.Group>
          </div>
          
          <div style={{ marginBottom: 16 }}>
            <Button 
              type="link" 
              size="small"
              onClick={this.handleToggleAdvancedOptions}
              icon={showAdvancedOptions ? <UpOutlined /> : <DownOutlined />}
            >
              {Lang.t('advancedOptions')}
            </Button>
            
            {showAdvancedOptions && (
              <div style={{ marginTop: 12, padding: 12, backgroundColor: '#f6f6f6', borderRadius: 4 }}>
                <Checkbox
                  checked={expandAllDepts}
                  onChange={(e) => this.setState({ expandAllDepts: e.target.checked })}
                >
                  {Lang.t('department.expandAllDepts')}
                </Checkbox>
                <div style={{ fontSize: 12, color: '#666', marginTop: 8 }}>
                  {Lang.t('department.expandAllDeptsDesc')}
                </div>
              </div>
            )}
          </div>
          
          {selectedDeptIds.length > 0 && (
            <div style={{ marginTop: 16, padding: 12, backgroundColor: '#f6ffed', borderRadius: 4 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <div>
                  <InfoCircleOutlined style={{ marginRight: 8 }} />
                  {Lang.t('department.selectedDepartmentsCount', selectedDeptIds.length)}
                  {Lang.t('space.boundDeptCount') && (
                    <Tag color="green" style={{ marginLeft: 8 }}>{selectedDeptIds.length}</Tag>
                  )}
                </div>
                {includeSubDepts && (
                  <Tag color="blue">{Lang.t('department.includeSubDepts')}</Tag>
                )}
              </div>
              
              <div style={{ maxHeight: 150, overflowY: 'auto', marginBottom: 8 }}>
                {selectedDeptIds.slice(0, 10).map((deptId, index) => {
                  const dept = this.findDeptById(deptId);
                  const isParent = dept?.children?.length > 0;
                  
                  return (
                    <div key={index} style={{ marginBottom: 4, padding: 4, backgroundColor: '#fff', borderRadius: 2 }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {isParent ? (
                          <ApartmentOutlined style={{ marginRight: 8, fontSize: 12, color: '#1890ff' }} />
                        ) : (
                          <TeamOutlined style={{ marginRight: 8, fontSize: 12, color: '#52c41a' }} />
                        )}
                        <span style={{ fontSize: 12 }}>
                          {dept ? dept.title : Lang.t('department.idFormat', deptId)}
                          {isParent && (
                            <Tag color="blue" style={{ marginLeft: 8, fontSize: 10 }}>
                              {Lang.t('department.parentNode')}
                            </Tag>
                          )}
                        </span>
                      </div>
                    </div>
                  );
                })}
                {selectedDeptIds.length > 10 && (
                  <div style={{ fontSize: 12, color: '#666', textAlign: 'center' }}>
                    {Lang.t('space.andMoreDepts')}
                  </div>
                )}
              </div>
              
              {includeSubDepts && (
                <Alert
                  type="info"
                  message={Lang.t('department.subDeptsHint')}
                  description={Lang.t('department.subDeptsHintDesc')}
                  showIcon
                  style={{ fontSize: 12 }}
                />
              )}
            </div>
          )}
          
          <Alert
            type="info"
            message={Lang.t('department.batchAddProcessNote')}
            description={
              <div style={{ fontSize: 12 }}>
                <div>1. {Lang.t('department.eachDeptIndependent')}</div>
                <div>2. {Lang.t('department.skipExistingMembers')}</div>
                <div>3. {Lang.t('department.setDefaultRole')}: 
                  <Tag color={this.spaceMemberRoleMap[batchAddRole]?.color} style={{ marginLeft: 4 }}>
                    {this.spaceMemberRoleMap[batchAddRole]?.name}
                  </Tag>
                </div>
                <div style={{ marginTop: 8, color: '#1890ff', fontWeight: 'bold' }}>
                  {Lang.t('department.parentNodeImportantHint')}
                </div>
              </div>
            }
            showIcon
          />
        </div>
      </Modal>
    );
  };

  render() {
    const { pager, modalState } = this;
    const { 
      space,
      syncDeptMembersLoading
    } = this.state;

    const columns: ColumnsType<SpaceMember> = [
      {
        title: Lang.t('member.memberAvatar'),
        dataIndex: 'user',
        responsive: ['md', 'lg', 'xl', 'xxl'],
        render: (user: User | null) => (
          <Link to={`/user/detail/${user?.uuid}`}>
            <img
              alt={Lang.t('member.avatarAlt')}
              className="avatar-small cursor"
              src={user?.getAvatarUrl()}
              onError={(e) => {
                (e.target as HTMLImageElement).src = '/static/image/default-avatar.png';
              }}
            />
          </Link>
        ),
      },
      {
        title: Lang.t('member.memberUsername'),
        dataIndex: 'user',
        render: (user: User | null) => {
          return (
            <div>
              <div>
                <Link to={`/user/detail/${user?.uuid}`}>{user?.username}</Link>
              </div>
              {this.currentUser.uuid === user?.uuid && (
                <div className="text-danger">{Lang.t('member.memberCurrentUser')}</div>
              )}
            </div>
          );
        },
      },
      {
        title: Lang.t('member.memberDepartment'),
        dataIndex: 'user',
        render: (user: User | null, record: SpaceMember) => {
          const deptId = record.fromDeptId || (user?.deptId);
          
          if (!deptId) return '--';
          
          const dept = this.findDeptById(deptId);
          return (
            <span>
              {dept ? dept.title : Lang.t('department.idFormat', deptId)}
            </span>
          );
        },
      },
      {
        title: Lang.t('member.memberRole'),
        dataIndex: 'role',
        render: (role: SpaceMemberRole) => {
          const roleInfo = this.spaceMemberRoleMap[role];
          return (
            <Tooltip title={getSpaceMemberRoleDescription(role)}>
              <Tag color={roleInfo?.color}>
                {roleInfo?.name}
              </Tag>
            </Tooltip>
          );
        },
      },
      {
        title: Lang.t('member.memberSource'),
        dataIndex: 'isDeptMember',
        responsive: ['lg', 'xl', 'xxl'],
        render: (isDeptMember: boolean, record: SpaceMember) => {
          const isFromDept = isDeptMember || record.isFromDept?.() || false;
          
          if (isFromDept) {
            const deptId = record.fromDeptId;
            const dept = deptId ? this.findDeptById(deptId) : null;
            const deptName = dept ? dept.title : Lang.t('department.idFormat', deptId);
            
            return (
              <Tooltip title={Lang.t('member.memberFromDepartmentWithName', deptName)}>
                <Tag icon={<ApartmentOutlined />} color="blue">
                  {Lang.t('department.department')}
                </Tag>
              </Tooltip>
            );
          }
          return (
            <Tooltip title={Lang.t('member.memberTooltipManual')}>
              <Tag icon={<UserOutlined />} color="green">
                {Lang.t('department.manual')}
              </Tag>
            </Tooltip>
          );
        },
      },
      {
        title: Lang.t('member.memberCreateTime'),
        dataIndex: 'createTime',
        responsive: ['md', 'lg', 'xl', 'xxl'],
        sorter: true,
        sortOrder: pager.getDefaultSortOrder('createTime'),
        sortDirections: [SortDirection.DESCEND, SortDirection.ASCEND],
        render: (text: Date) => DateUtil.simpleDateTime(text),
      },
      {
        title: Lang.t('member.memberOperation'),
        render: (_, record: SpaceMember) =>
          this.spaceMember.role === SpaceMemberRole.ADMIN ? (
            <AntdSpace>
              <Tooltip title={Lang.t('member.memberEdit')}>
                <Typography.Link>
                  <EditOutlined
                    className="btn-action"
                    onClick={() => this.handleEdit(record)}
                  />
                </Typography.Link>
              </Tooltip>
              <Tooltip title={Lang.t('space.memberUnbind')}>
                <Popconfirm
                  title={
                    record.isDeptMember ? (
                      <div>
                        <div style={{ marginBottom: 8 }}>
                          <strong>{Lang.t('member.deleteDeptMemberConfirm')}</strong>
                        </div>
                        <div>
                          <p>{Lang.t('member.deleteDeptMemberWarning')}</p>
                          <ul style={{ margin: '8px 0', paddingLeft: 16 }}>
                            <li>{Lang.t('member.willNotAutoAddAgain')}</li>
                            <li>{Lang.t('member.canManuallyReadd')}</li>
                            <li>{Lang.t('member.deptSyncWillSkip')}</li>
                          </ul>
                          <Alert 
                            type="warning" 
                            message={Lang.t('member.syncWillNotReadd')}
                            showIcon 
                          />
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div style={{ marginBottom: 8 }}>
                          <strong>{Lang.t('space.memberUnbindConfirm')}</strong>
                        </div>
                        <div>
                          {Lang.t('space.memberUnbindConfirmDesc')}
                        </div>
                      </div>
                    )
                  }
                  okText={Lang.t('common.confirm')}
                  cancelText={Lang.t('common.cancel')}
                  okType="danger"
                  onConfirm={() => this.handleDelete(record)}
                >
                  <DeleteOutlined
                    className="btn-action"
                    style={{ color: Color.DANGER, cursor: 'pointer' }}
                  />
                </Popconfirm>
              </Tooltip>
            </AntdSpace>
          ) : null,
      },
    ];

    return (
      <div className="page-space-member-list">
        <HwzTitle name={Lang.t('space.memberManagement')}>
          <AntdSpace>
            {this.spaceMember.role === SpaceMemberRole.ADMIN && (
              <>
                <Button 
                  type="primary" 
                  onClick={() => this.handleCreate()}
                  icon={<UserOutlined />}
                >
                  {Lang.t('batchBindMember')}
                </Button>
                
                <Button 
                  type="primary" 
                  onClick={this.handleOpenBatchModal}
                  icon={<UsergroupAddOutlined />}
                >
                  {Lang.t('department.batchAddByDept')}
                </Button>
                
                {space.deptIds && space.deptIds.length > 0 && (
                  <Badge count={space.deptIds.length} offset={[5, 0]}>
                    <Button 
                      icon={<TeamOutlined />}
                      onClick={this.handleSyncDeptMembers}
                      loading={syncDeptMembersLoading}
                    >
                      {Lang.t('space.boundDeptCount', space.deptIds.length)}
                    </Button>
                  </Badge>
                )}
              </>
            )}
          </AntdSpace>
        </HwzTitle>

        {this.renderFilterToolbar()}

        {this.renderStats()}

        <Table
          rowKey="uuid"
          loading={pager.loading}
          dataSource={pager.data}
          columns={columns}
          pagination={pager.getPagination()}
          onChange={pager.tableOnChange.bind(pager)}
          locale={{
            emptyText: (
              <TableEmpty pager={pager} onRefresh={this.refresh.bind(this)} />
            ),
          }}
          scroll={{ x: 800 }}
        />
        
        {modalState.visible && (
          <ModalForm
            mode={modalState.mode}
            initialValues={modalState.initialValues}
            onOk={this.handleConfirmModalForm.bind(this)}
            onCancel={() => this.handleHideModalForm()}
          />
        )}
        
        {this.renderBatchAddModal()}
        
        {this.renderRoleUpdateModal()}
      </div>
    );
  }
}